import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { mapCustomerAddressInformation } from "../utils/customerAddressInformation"

export const queryCustomerAddress = {
  async customerAddress(parent, args, context, info) {
    const { customerId, customerKey, customerNumber, addressId } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.READ,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    if (customer?.addresses?.length <= 0) return null

    const targetAddress = customer.addresses.find((address) => address?.id === addressId)

    if (!targetAddress) return null

    const address = mapCustomerAddressInformation(targetAddress, customer)

    return address
  },
}
